import React from 'react'
import _ from 'lodash'
import { Row } from 'antd'
import moment from 'moment'
import { P } from 'konsys-ui'
import defaultContents, { Remarks } from './detail/contents'
import CompoenentRenderer from './detail/component-renderer'
import { Wrapper } from '../../components/shipping-order-components'
import { detailMode, status as shippingStatus } from './constants'
import history from '../../history'
import br from '../../assets/br.jpeg'
import ktis from '../../assets/ktis.jpeg'
import mitrpol from '../../assets/mitrphol.png'
import thaiagro from '../../assets/thaiagro.png'
import df from '../../assets/default.jpeg'

export const logoSelector = (company) => {
  switch (company) {
    case 39:
    case 40:
    case 41:
    case 42:
      return mitrpol
    case 4:
    case 5:
      return ktis
    case 37:
      return br
    case 19:
      return thaiagro
    default:
      return df
  }
}

export const isLatedMoreThan15days = (status, assignDate) => status === shippingStatus.EXPIRED && moment(assignDate).diff(moment(), 'd') < -15

export const isLatedMoreThan60days = (status, assignDate) => status === shippingStatus.EXPIRED && moment(assignDate).diff(moment(), 'd') < -60

const RowRenderer = ({
  data, mode, onChangeHandler, initialData, client, driverDataHandler, fuelTypeHandler, accessFuel, accessDelivered, accessDriver, jobData, mutationVariables, onlyStartEndDestination,
}) => data.map(v => (
  <CompoenentRenderer
    onChangeHandler={(id, value) => onChangeHandler(id, value)}
    key={v.id}
    data={v}
    mode={mode}
    initialData={initialData}
    client={client}
    driverDataHandler={driverDataHandler}
    fuelTypeHandler={fuelTypeHandler}
    accessFuel={accessFuel}
    accessDelivered={accessDelivered}
    accessDriver={accessDriver}
    jobData={jobData}
    mutationVariables={mutationVariables}
    onlyStartEndDestination={onlyStartEndDestination}
  />
))

const DetailModeHandler = (params, onChangeHandler, client, driverDataHandler, fuelTypeHandler, accessFuel, accessDelivered, accessDriver, mutationVariables, jobData, initialData, onlyStartEndDestination) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return defaultContents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='middle'
            // justify='center'
            type='flex'
            gutter={12}
          >
            <RowRenderer mutationVariables={mutationVariables} accessDelivered={accessDelivered} accessFuel={accessFuel} accessDriver={accessDriver} data={v} mode={mode} onChangeHandler={(id, value) => onChangeHandler(id, value)} client={client} driverDataHandler={driverDataHandler} fuelTypeHandler={fuelTypeHandler} jobData={jobData}/>
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      // if (_.isUndefined(params.id)) history.push('/shipping-order')
      // mockup data
      return defaultContents.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='middle'
            // justify='center'
            type='flex'
            gutter={12}
          >
            <RowRenderer onlyStartEndDestination={onlyStartEndDestination} mutationVariables={mutationVariables} accessDelivered={accessDelivered} accessFuel={accessFuel} accessDriver={accessDriver} data={v} mode={mode} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)} client={client} driverDataHandler={driverDataHandler} fuelTypeHandler={fuelTypeHandler}/>
          </Row>
        </Wrapper>
      ))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export const RemarksDetailModeHandler = (params, onChangeHandler, client, accessFuel, accessDelivered, accessDriver, initialData, onlyStartEndDestination) => {
  const mode = params.mode.toUpperCase()
  switch (mode) {
    case detailMode.ADD:
      return Remarks.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='middle'
            // justify='center'
            type='flex'
            gutter={12}
          >
            <RowRenderer data={v} mode={mode} onChangeHandler={(id, value) => onChangeHandler(id, value)} client={client}/>
          </Row>
        </Wrapper>
      ))
    case detailMode.EDIT:
    case detailMode.VIEW:
    {
      // if (_.isUndefined(params.id)) history.push('/shipping-order')
      // mockup data
      return Remarks.map((v, i) => (
        <Wrapper key={i}>
          <Row
            align='middle'
            // justify='center'
            type='flex'
            gutter={12}
          >
            <RowRenderer onlyStartEndDestination={onlyStartEndDestination} data={v} mode={mode} initialData={initialData} onChangeHandler={(id, value) => onChangeHandler(id, value)} client={client}/>
          </Row>
        </Wrapper>
      ))
    }
    default:
      return <P>Something went wrong!</P>
  }
}

export default DetailModeHandler
